import React from 'react';

const NoMatch = () => {
    return (
        <div>
            <h2 className="text-center">Not found this result</h2>
            <h3 className="text-center">Error: 404</h3>

        </div>
    );
};

export default NoMatch;